module.exports = __webpack_public_path__ + "static/img/rest.7c6ce9f0.png";